import BrandLogo from "./BrandLogo";

import { getThemeComponentClasses } from "@/shared/lib/themeComponentClasses";

type HeaderBrandProps = {
  variant?: "default" | "header" | "sidebar";
};

export default function HeaderBrand({ variant = "default" }: HeaderBrandProps) {
  const componentClasses = getThemeComponentClasses();
  const textClassName =
    variant === "header"
      ? componentClasses?.header?.brandTextColor
      : variant === "sidebar"
        ? componentClasses?.sidebar?.brandTextColor
        : "";
  const imageClassName =
    variant === "sidebar" ? "h-7 w-auto max-w-[140px] object-contain" : undefined;

  return <BrandLogo textClassName={textClassName || undefined} imageClassName={imageClassName} />;
}
